import {GET_CAMPAIGN, GET_CAMPAIGN_DATA, GET_CAMPAIGN_END, GET_CAMPAIGN_START} from '../slices/type'

interface InitState {
    data: any[]; 
    dataSingle: any[]; 
    loading: boolean;
}

const initState: InitState = {
    data: [],
    dataSingle: [],
    loading: false,
};

interface Action {
    type: string;
    payload?: any; 
    loading?: boolean;
}

const getCampaign_Red = (state = initState, action: Action): InitState => {
    switch (action.type) {
        case GET_CAMPAIGN_START:
            return {
                ...state,
                loading: action.loading ?? false, 
            };
        case GET_CAMPAIGN_DATA:
            return {
                ...state,
                data: action.payload ?? [],
                loading: action.loading ?? false,
            };
        case GET_CAMPAIGN_END:
            return {
                ...state,
                dataSingle: action.payload ?? [],
                loading: action.loading ?? false,
            };
        default:
            return state;
    }
};

export default getCampaign_Red;
